import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function ArticlesGrid() {
  return (
    <section id="articles" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
            SEO Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Pandabuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Expert guides, comparisons, and tips to help you master Pandabuy shopping. Updated regularly with fresh insights.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-background-50/90 text-foreground-800 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between pt-3 border-t border-background-200/50">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-foreground-900 hover:bg-foreground-800 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            View All Shopping Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}